module.exports = __webpack_public_path__ + "media/images/saiba_mais03-5177567ae6acacbd9b47bd3f8950d0d1.png";